import { render, staticRenderFns } from "./UploadViewer.vue?vue&type=template&id=b27beff2&"
import script from "./UploadViewer.vue?vue&type=script&lang=js&"
export * from "./UploadViewer.vue?vue&type=script&lang=js&"
import style0 from "./UploadViewer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports